export const REQUEST_EDITRESPONDANTDATAGENPOOL = 'REQUEST_EDITRESPONDANTDATAGENPOOL';
export const EDITRESPONDANTDATAGENPOOL_RECEIVED = 'EDITRESPONDANTDATAGENPOOL_RECEIVED';